import React from 'react';
import Layout from '../../components/Layout';
import ProviderProfile from './ProviderProfile';
import NotFound from '../../components/NotFound/NotFound';
import getProviderProfileQuery from './getProviderProfile.graphql';

// Public provider profile: /pro/:id
async function action({ params, client, store }) {
  const siteTitle =
    (store.getState().siteSettings && store.getState().siteSettings.data && store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  let pro = null;
  try {
    const { data } = await client.query({
      query: getProviderProfileQuery,
      variables: { id: params.id },
      fetchPolicy: 'network-only',
    });
    pro = data && data.getProviderProfile;
  } catch (e) {
    pro = null;
  }

  if (!pro || pro.status !== 200) {
    return { title: `Page Not Found | ${siteTitle}`, component: (<Layout><NotFound title={'Page Not Found'} /></Layout>) };
  }

  const name = `${pro.firstName || 'Pro'} ${pro.lastName || ''}`.trim();
  return {
    title: `${name} — verified pro | ${siteTitle}`,
    // COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod.
    description: `${name} is a background-checked pro on BestHand${pro.reviewCount ? `, rated ${pro.avgRating}/5 from ${pro.reviewCount} reviews` : ''}. Book trusted local home services.`,
    component: (<Layout><ProviderProfile pro={pro} /></Layout>),
  };
}

export default action;
